import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): la nota informativa
// `role="status"` (advertencia de "sin lugares habilitados", aviso de
// "el tipo nuevo aplica a consumos futuros") repetía el mismo estilo,
// palabra por palabra, dentro de BenefitsScreen.tsx y también en
// RewardsScreen.tsx. Extracción sin cambio de comportamiento ni de valores
// visuales.
export function InlineNote({ children }: { children: ReactNode }) {
  return (
    <div
      role="status"
      style={{
        margin: "0 0 16px",
        padding: "10px 12px",
        borderRadius: 11,
        border: `1px solid ${tokens.surface.line}`,
        background: tokens.surface.surface,
        color: tokens.text.secondary,
        font: `400 12.5px ${tokens.font.ui}`,
      }}
    >
      {children}
    </div>
  );
}
